import { render, staticRenderFns } from "./CardTravel.vue?vue&type=template&id=44ee6598&"
import script from "./CardTravel.vue?vue&type=script&lang=js&"
export * from "./CardTravel.vue?vue&type=script&lang=js&"
import style0 from "./CardTravel.vue?vue&type=style&index=0&id=44ee6598&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports